export default {

    "fields" : {
        "firstname": {
            "required" : "حقل الاسم الشخصي مطلوب",
        },
        "firstname_ar": {
            "required" : "حقل الاسم الشخصي باللغة العربية مطلوب",
        },
        "lastname": {
            "required" : "حقل الاسم العائلي مطلوب",
        },
        "lastname_ar": {
            "required" : "حقل الاسم العائلي باللغة العربية مطلوب",
        },
        "email": {
            "required": "حقل عنوان البريد الإلكتروني مطلوب",
            "invalid" : "حقل عنوان البريد الإلكتروني غير صالح",
        },
        "password": {
            "required": "حقل كلمة المرور مطلوب",
            "short": "كلمة المرور قصيرة جدا",
            "different": "يجب أن تكون كلمات المرور متطابقة",
        },
        "password_confirmation" : {
            "required": "حقل تأكيد كلمة المرور مطلوب",
            "short" : "كلمة مرور التأكيد قصيرة جدا",
        },
        "current_password" : {
            "required": "كلمة المرور الحالية مطلوبة",
            "invalid" : "كلمة المرور الحالية غير صالحة",
        },
        "new_password" : {
            "required" : "حقل كلمة المرور الجديدة مطلوب",
            "short" : "كلمات المرور الجديدة قصيرة جدا"
        },
        "mobile": {
            "required" : "حقل رقم الهاتف المحمول مطلوب",
            "invalid" : "حقل رقم الهاتف الجوال غير صالح",
        },
        "phone" : {
            "required" : "حقل رقم الهاتف الثابت مطلوب",
            "invalid" : "حقل رقم الهاتف الثابت غير صالح",
        },
        "officePhone" : {
            "required" : "حقل رقم هاتف المكتب مطلوب",
            "invalid" : "حقل رقم هاتف المكتب غير صالح",
        },
        "fax" : {
            "required" : "حقل رقم هاتف الفاكس مطلوب",
            "invalid" : "حقل رقم هاتف الفاكس غير صالح",
        },
        "birthday": {
            "required" : "حقل تاريخ الميلاد مطلوب",
            "invalid" : "تاريخ الميلاد غير صالح"
        },
        "city" : {
            "required" : "حقل المدينة مطلوب",
        },
        "city_ar" : {
            "required" : "حقل المدينة باللغة العربية مطلوب",
        },
        "address" : {
            "required" : "حقل العنوان مطلوب",
        },
        "address_ar" : {
            "required" : "حقل العنوان باللغة العربية مطلوب",
        },
        "terms" : {
            "required" : "قبول شروط الاستخدام العامة إلزامي",
        },
        "verification_code" : {
            "required" : "حقل رمز التحقق مطلوب",
            "invlaid" : "الحقل رمز التحقق غير صالح",
        },
        "facebook" : {
            "required" : "حقل رابط الفيسبوك مطلوب",
            "invalid" : "حقل رابط الفيسبوك غير صالح",
        },
        "twitter" : {
            "required" : "حقل رابط التويتر مطلوب",
            "invalid" : "حقل رابط التويتر غير صالح",
        },
        "google_plus" : {
            "required" : "حقل رابط قوقل بلوس مطلوب",
            "invalid" : "حقل رابط قوقل بلوس مطلوب",
        },
        "speciality" : {
            "required" : "حقل التخصص مطلوب",
        },
        "motif" : {
            "required" : "حقل دواعي الزيارة مطلوب",
        },
        "gender" : {
            "required" : "حقل الجنس مطلوب",
        },
        "comment" : {
            "required" : "حقل التعليق مطلوب",
        },
        "treatment" : {
            "required" : "حقل الإجراءات و العلاجات مطلوب",
        },
        "pack" : {
            "required" : "حقل العرض مطلوب",
        },
        "message" : {
            "required" : "حقل الرسالة مطلوب",
        }
    },
    "messages": {
        "password_reseted": "تم إعادة تعيين كلمة المرور الخاصة بك.",
        "incorrect_credentials" : "عنوان بريدك الإلكتروني أو كلمة المرور غير صحيحة، يرجى التحقق من المعلومات التي تم إدخالها. ",
        "email_inconfirmed" : "عذرا لم يتم تأكيد عنوان البريد الإلكتروني الخاص بك، تحقق من بريدك الالكتروني لتأكيد تسجيلك. ",
        "account_inconfirmed" : "لم يتم تأكيد هذا الحساب، يرجى تأكيد حسابك. ",
        "connecting": "جاري الاتصال",
        "login": "تسجيل الدخول",
        "reset" : "إعادة التعيين",
        "resetting" : "إعادة التعيين",
        "password_reset_email_sended" : "تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور. ",
        "email_exist_already" : "عنوان البريد الإلكتروني هذا موجود من قبل ",
        "please_wait": "من فضلك انتظر",
        "request_saved" : "تم حفظ طلبك. ",
        "error_has_occurred" : "حدث خطأ",
        "summary" : "ملخص",
        "email_sended_to_client" : "تم إرسال بريد إلكتروني إلى المريض",
        "canceled": "ألغي",
        "end_time_must_be_greater": "يجب أن يكون وقت الانتهاء أكبر من وقت البدء",
        "prove_humanity" : "أكد أنك لست روبوت",
        "contact_message_sended" : "تم إرسال رسالتك. وسوف نقوم بالرد عليك في أقرب وقت ممكن.",
        "sending" : "يتم الإرسال",
        "patient_infos" : "بيانات المريض",
        "appointments" : "المواعيد",
        "dhs" : "درهم",
        "min" : "دقيقة",
        "account_data_saved" : "تم حفظ البيانات المتعلقة بحسابك بنجاح.",
        "price" : "الثمن",
        "not_available" : "غير متوفر",
        "patient_history_empty" : "لائحة المرضى فارغة",
        "delete" : "حذف",
        "show_more_appointments": "إظهار باقي المواعيد",
        "hide_extra_appointments" : "عودة",
        "show_number": "إظهار الرقم",
        "thank_you" : "شكرا لك",
        "we_will_contact_you_soon" : ".سوف نتصل بك قريبا",

        "appointment" : {
            "cancel_it": "أنت على وشك إلغاء هذا الموعد، هل أنت متأكد؟",
            "canceled" : "تم إلغاء الموعد",
            "delete_error" : "حدث خطأ أثناء حذف الموعد",
            "already_taken": "هذا الموعد محجوز قبلا من طرف مريض آخر",
            "already_exists" :"الموعد موجود سلفا",
            "details" : "تفاصيل الموعد",
            "take_it" : "حجز الموعد",
            "take" : "إحجز موعدا",
            "date" : "تاريخ الموعد",
            "time" : "الموعد على الساعة",
            "end" : "انتهاء الموعد",
            "validated" : "تم حجز الموعد بنجاح",
            "none_this_day" : "لا توجد أية مواعيد متاحة في هذا اليوم",
            "shifted" : "تم تأجيل الموعد بنجاح",
            "select" : "إختر موعد",
            "shift_date_invalid" : "تاريخ التأجيل غير صالح",
            "expired" : "انتهت صلاحية هذا الموعد",
            "click_to_join" : "يرجى النقر على الزر أدناه للولوج إلى الإستشارة عبر تقنية الفيديو",
        }
    }
};
